
import screen from "./screen";

function clamp (params = {}) {
    const {value, min, max} = params;
    return Math.min(Math.max(value, min), max);
}

$(function() {
    const $document = $(document);
    const $header = $("#header");
    const $template = $('#design-template');
    const $ad = $("#ad-north-rsvp, #ad_mobile_top", $header).parent();
    const $navContainer = $('.nav-container');
    const $subNav = $("#gallery-nav", $header);
    const $actionBar = $('.action-bar');
    const $fullPreviewBar = $("#full_preview_bar", $header);
    let navTop = 0;

    $(window).scroll(handleScroll);
    handleScroll();

    function handleScroll(){
        let scrollTop = $document.scrollTop();
        let headerMarginTop = calculateHeaderMarginTop(scrollTop);
        $header.css("margin-top", headerMarginTop + "px");
        navTop = scrollTop + headerMarginTop;
    }

    function calculateHeaderMarginTop(scrollTop){
        if(screen.isSmall()){
            return 0;
        }

        const fadeBoundary =
            screen.isSmall()? 300:
            $actionBar.length? $template.outerHeight() - $actionBar.outerHeight():
            $template.outerHeight() - $navContainer.outerHeight();

        const adTop = $actionBar.length?
            Math.max(0, fadeBoundary):
            Math.max(0, fadeBoundary + $navContainer.outerHeight());

        if(scrollTop <= adTop){
            return 0;
        }

        let inverseNavSize = -1 * ($header.outerHeight() - $subNav.outerHeight());
        if (window.cookie_dismissed) {
            window.cookie_dismissed = false;
            inverseNavSize = inverseNavSize + 30;
        }

        let isBetweenAdTopAndSubNav = scrollTop > adTop && scrollTop < (adTop - inverseNavSize);
        let isBetweenNavBoundaryAndSubNav = scrollTop < navTop && scrollTop < (navTop - inverseNavSize);
        if (isBetweenAdTopAndSubNav && isBetweenNavBoundaryAndSubNav){
            return clamp({value: inverseNavSize + navTop - scrollTop, min: inverseNavSize, max: 0});
        }
        else if(screen.isLarge() && isBetweenAdTopAndSubNav){
            return clamp({value: adTop - scrollTop, min: inverseNavSize, max: 0});
        }
        else if(screen.isMedium()){
            return clamp({value: adTop - scrollTop, min: inverseNavSize + $navContainer.outerHeight(), max: 0});
        }

        let adMargin = $ad.length ? -1 * $header.outerHeight() : -50;
        if($fullPreviewBar.length){
            adMargin -= $fullPreviewBar.outerHeight()
        }

        if(isBetweenNavBoundaryAndSubNav){
            return clamp({value: inverseNavSize + navTop - scrollTop, min: inverseNavSize, max: adMargin});
        }
        else if(!$subNav.length) {
            return adMargin;
        }

        return inverseNavSize;
    }
});



// WEBPACK FOOTER //
// ./assets/es6/common/subnav.es6